/**
 * EmbedPage — the tiny React page loaded inside the /embed.js iframe.
 * Renders only the ChatWidget so operator websites get a floating chat
 * without any of the /join page chrome.
 */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import ChatWidget from "../components/ChatWidget";

export default function EmbedPage() {
  const { slug } = useParams();
  const [biz, setBiz] = useState(null);

  useEffect(() => {
    if (!slug) return;
    api.get(`/public/business/${slug}`).then((r) => setBiz(r.data)).catch(() => setBiz({ business_name: "BuzzerAI", public_features: { ai_chat: false } }));
  }, [slug]);

  if (!biz) return null;

  return (
    <div style={{ background: "transparent" }} data-testid="embed-page">
      <ChatWidget slug={slug} businessName={biz.business_name} enabled={biz.public_features?.ai_chat} />
    </div>
  );
}
